import { Component, EventEmitter, Output } from '@angular/core';
import { IconComponent } from 'components/layout/icon/icon.component';
import { TranslatePipe } from 'pipes/translate.pipe';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Skeletons } from 'components/shared/skeleton/skeletons';
import { ButtonComponent } from 'components/input/button/button.component';
import { environment } from 'environments/environment';
import { CredentialService } from 'services/credential.service';

interface AuthGroup {
	name: string;
	session: string;
	hasAccessToken: boolean;
	credential: string;
}

export const screenUrl = environment.environment === 'prod' ? 'https://go-prod-app-screenclient.azurewebsites.net' : 'https://go-prod-app-screenclient-test.azurewebsites.net';

@Component({
	selector: 'screen-authenticator',
	templateUrl: './screen-authenticator.component.html',
	styleUrl: './screen-authenticator.component.scss',
	imports: [IconComponent, TranslatePipe, Skeletons, ButtonComponent]
})
export class ScreenAuthenticatorComponent {

	@Output() onClose = new EventEmitter();

	screenAuthGroups?: AuthGroup[];

	constructor(private readonly http: HttpClient, private readonly credentialService: CredentialService) {
		this.getScreenAuthGroups();
	}

	async getScreenAuthGroups() {
		const authGroups = await firstValueFrom(this.http.get<AuthGroup[]>(`${screenUrl}/PowerBi/GetAuthGroups`));
		this.screenAuthGroups = authGroups.filter(ag => this.credentialService.hasCustomCredentials(ag.credential));
	}

	async generateAccessToken(authGroup: AuthGroup) {
		this.screenAuthGroups = undefined;
		await firstValueFrom(this.http.get(`${screenUrl}/PowerBi/CreateAuthentication?authGroupIdentification=${authGroup.name}`));
		this.getScreenAuthGroups();
	}
}
